/**
 * LIVVRA — Cart Page Checkout (Cashfree Integration)
 * Full Online Payment + COD Advance ₹150
 *
 * ⚙️  SETUP: Set your backend URL below (your Replit app URL)
 */

// Replace this one URL after publishing the backend on Replit.
const LV_BACKEND = 'https://themeexportlivvraindia-com-livvra-shopify-theme-124-jul--ppmet.replit.app';

// ─────────────────────────────────────────────────────────────
// Cart quantity update (AJAX)
// ─────────────────────────────────────────────────────────────
function lvUpdateQty(key, qty) {
  const row = Array.from(document.querySelectorAll('.lv-ci[data-key]'))
    .find(el => el.getAttribute('data-key') === key);
  if (row) {
    if (qty === 0) row.remove();
    else {
      row.querySelectorAll('.lv-ci-qty-num, .lv-ci-qty-badge').forEach(el => { el.textContent = qty; });
      const buttons = row.querySelectorAll('.lv-ci-qty-btn');
      if (buttons[0]) buttons[0].setAttribute('onclick', `lvUpdateQty(${JSON.stringify(key)}, ${Math.max(0, qty - 1)})`);
      if (buttons[1]) buttons[1].setAttribute('onclick', `lvUpdateQty(${JSON.stringify(key)}, ${qty + 1})`);
    }
  }
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty }),
  })
    .then(r => r.json())
    .then(async response => {
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      const subtotal = document.getElementById('lvSubtotal');
      const total = document.getElementById('lvTotal');
      const totalPaise = document.getElementById('lvTotalPaise');
      const money = `₹${Math.round(cart.total_price / 100).toLocaleString('en-IN')}`;
      if (subtotal) subtotal.textContent = money;
      if (total) total.textContent = money;
      if (totalPaise) totalPaise.textContent = cart.total_price;
      document.querySelectorAll('.lv-cart-count-badge').forEach(el => {
        el.textContent = `${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`;
      });
      if (cart.item_count === 0) window.location.reload();
    })
    .catch(() => window.location.reload());
}

// ─────────────────────────────────────────────────────────────
// Form validation helper
// ─────────────────────────────────────────────────────────────
function lvValidateForm() {
  const name    = document.getElementById('lvName').value.trim();
  const phone   = document.getElementById('lvPhone').value.replace(/\D/g, '');
  const address = document.getElementById('lvAddress').value.trim();
  const city    = document.getElementById('lvCity').value.trim();
  const state   = document.getElementById('lvState').value;
  const pincode = document.getElementById('lvPincode').value.trim();

  if (!name)                return 'Poora naam daalna zaroori hai.';
  if (phone.length !== 10)  return 'Sahi 10-digit mobile number daalo.';
  if (!address)             return 'Delivery address daalna zaroori hai.';
  if (!city)                return 'Shahar ka naam daalo.';
  if (!state)               return 'Rajya chunein.';
  if (!/^\d{6}$/.test(pincode)) return 'Sahi 6-digit PIN code daalo.';
  return null;
}

function lvShowError(msg) {
  const el = document.getElementById('lvFormError');
  if (!el) return;
  el.textContent = '⚠️ ' + msg;
  el.style.display = 'block';
  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

function lvHideError() {
  const el = document.getElementById('lvFormError');
  if (el) el.style.display = 'none';
}

// ─────────────────────────────────────────────────────────────
// Get form data
// ─────────────────────────────────────────────────────────────
function lvGetFormData() {
  return {
    customer_name    : document.getElementById('lvName').value.trim(),
    customer_phone   : document.getElementById('lvPhone').value.replace(/\D/g, ''),
    customer_email   : document.getElementById('lvEmail').value.trim() || 'orders@livvraindia.com',
    customer_address : document.getElementById('lvAddress').value.trim(),
    customer_city    : document.getElementById('lvCity').value.trim(),
    customer_state   : document.getElementById('lvState').value,
    customer_pincode : document.getElementById('lvPincode').value.trim(),
    cart_total       : parseInt(document.getElementById('lvTotalPaise').textContent, 10),
    cart_items       : [], // populated below
  };
}

// ─────────────────────────────────────────────────────────────
// Set buttons loading / normal state
// ─────────────────────────────────────────────────────────────
function lvSetLoading(loading) {
  const btnOnline = document.getElementById('lvBtnOnline');
  const btnCod    = document.getElementById('lvBtnCod');
  if (!btnOnline || !btnCod) return;
  if (loading) {
    btnOnline.disabled = true;
    btnCod.disabled    = true;
    btnOnline.classList.add('lv-loading');
    btnCod.classList.add('lv-loading');
  } else {
    btnOnline.disabled = false;
    btnCod.disabled    = false;
    btnOnline.classList.remove('lv-loading');
    btnCod.classList.remove('lv-loading');
  }
}

// ─────────────────────────────────────────────────────────────
// Show success overlay
// ─────────────────────────────────────────────────────────────
function lvShowSuccess(isCod, advance, remaining) {
  // Clear cart
  fetch('/cart/clear.js', { method: 'POST' }).catch(() => {});

  const overlay = document.getElementById('lvSuccessOverlay');
  const title   = document.getElementById('lvSuccessTitle');
  const msg     = document.getElementById('lvSuccessMsg');

  if (isCod) {
    title.textContent = '✅ COD Advance Pay Ho Gaya!';
    msg.textContent   = `₹${advance} advance successfully paid. Baaki ₹${remaining} delivery ke samay dena hoga. Order jald aayega!`;
  } else {
    title.textContent = '✅ Payment Successful!';
    msg.textContent   = 'Aapka order place ho gaya hai. Order details aapke email par bhej di gayi hain.';
  }

  if (overlay) overlay.style.display = 'flex';
}

// ─────────────────────────────────────────────────────────────
// Main payment handler
// ─────────────────────────────────────────────────────────────
async function lvStartPayment(type) {
  lvHideError();

  const err = lvValidateForm();
  if (err) { lvShowError(err); return; }

  lvSetLoading(true);

  const formData = lvGetFormData();

  // Fetch cart items from Shopify
  try {
    const cartRes  = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!cartRes.ok) throw new Error('Cart unavailable');
    const cartJson = await cartRes.json();
    formData.cart_items = (cartJson.items || []).map(i => ({
      variant_id : i.variant_id,
      product_id : i.product_id,
      title      : i.product_title,
      variant    : i.variant_title !== 'Default Title' ? i.variant_title : '',
      quantity   : i.quantity,
      price_paise: i.final_price,
    }));
  } catch (_) { /* ignore, cart_items optional */ }

  const endpoint = type === 'cod'
    ? `${LV_BACKEND}/api/cashfree/create-cod-advance`
    : `${LV_BACKEND}/api/cashfree/create-order`;

  let orderData;
  try {
    const res = await fetch(endpoint, {
      method : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body   : JSON.stringify(formData),
    });
    orderData = await res.json();
    if (!res.ok) {
      lvShowError(orderData.error || 'Order create karne mein problem aayi. Dobara try karein.');
      lvSetLoading(false);
      return;
    }
  } catch (e) {
    lvShowError('Network error. Internet check karein aur dobara try karein.');
    lvSetLoading(false);
    return;
  }

  const { payment_session_id, advance_amount, remaining_amount } = orderData;
  if (!payment_session_id) {
    lvShowError('Payment session nahi bana. Backend settings check karke dobara try karein.');
    lvSetLoading(false);
    return;
  }

  // ── Open Cashfree Checkout ──
  try {
    if (typeof Cashfree !== 'function') throw new Error('Cashfree SDK not loaded');
    const cashfree = Cashfree({ mode: 'production' }); // Change to 'sandbox' for testing

    const checkoutOptions = {
      paymentSessionId: payment_session_id,
      redirectTarget  : '_modal',
    };

    cashfree.checkout(checkoutOptions).then(result => {
      lvSetLoading(false);
      if (result.error) {
        lvShowError('Payment cancel ya fail ho gaya. Dobara try karein.');
        console.error('Cashfree error:', result.error);
        return;
      }
      if (result.paymentDetails) {
        // Payment successful
        lvShowSuccess(type === 'cod', advance_amount, remaining_amount);
      }
    }).catch(e => {
      lvSetLoading(false);
      lvShowError('Payment window nahi khul rahi. Please refresh karein.');
      console.error('Cashfree checkout error:', e);
    });
  } catch (e) {
    lvSetLoading(false);
    lvShowError('Payment system load nahi hua. Page refresh karein.');
    console.error('Cashfree init error:', e);
  }
}

// ─────────────────────────────────────────────────────────────
// Phone: only digits, max 10
// ─────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  const phoneEl = document.getElementById('lvPhone');
  if (phoneEl) {
    phoneEl.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, 10);
    });
  }

  const pincodeEl = document.getElementById('lvPincode');
  if (pincodeEl) {
    pincodeEl.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, 6);
    });
  }

  // Check for payment return from Cashfree (redirect mode fallback)
  // Only trigger on /cart page (lvSuccessOverlay must exist)
  const params = new URLSearchParams(window.location.search);
  if (params.get('cf_order_id') && params.get('livvra_id') && document.getElementById('lvSuccessOverlay')) {
    const isCod = params.get('type') === 'cod';
    lvShowSuccess(isCod, 150, null);
    // Clean URL
    window.history.replaceState({}, document.title, window.location.pathname);
  }
});
